import React from 'react'
import PropTypes from 'prop-types'


class BoxText extends React.Component {
  render() {
    const { size, color, strong } = this.props
    const style = {
      fontSize: size,
      color: color
    }

    return (
      <div style={style}>
        {
          strong
          ? (<strong>{this.props.children}</strong>)
          : this.props.children
        }
      </div>
    )
  }
}

BoxText.propTypes = {
  size: 14,
  color: '#333',
  strong: false
}

BoxText.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  strong: PropTypes.bool,
}

export default BoxText



// WEBPACK FOOTER //
// ./src/components/widgets/BoxText.js